import React, {useState} from "react";
import {Image, Popup} from "semantic-ui-react";
import valpur from "../images/concerts/valpur.jpg";
import descent from "../images/concerts/descent.jpg";
import Link from "@mui/material/Link";


export default function Concerts() {
    return <div>

        <div style={{
            marginTop: 30,
            display: "flex",
            justifyContent: "center",
            flexDirection: 'column',
            alignItems: 'center'
        }}>

            {/*<div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>*/}
            {/*    <video*/}
            {/*        controls*/}
            {/*        preload="auto"*/}
            {/*        width={'50%'}*/}
            {/*        autoPlay={true}*/}
            {/*        // poster={video_home_2_poster}*/}
            {/*    >*/}
            {/*        <source src={halloween} type="video/mp4"/>*/}
            {/*        <p className="vjs-no-js">*/}
            {/*            Для просмотра этого видео включите выполнение JavaScript или обновите браузер*/}
            {/*        </p>*/}
            {/*    </video>*/}
            {/*    <div style={{marginTop: 40}}>*/}
            {/*        <div>DARK STORY OF HALLOWEEN</div>*/}
            {/*        <pre style={{maxWidth: 600, textWrap: 'wrap', whiteSpace: 'pre-wrap', wordWrap: 'break-word', overflowWrap: 'break-word'}} className={'PalatinoFont'}>{"🔥Стартуем!🔥\n" +*/}
            {/*        "Друзья, объявляем старт продажи билетов!\n" +*/}
            {/*        "\n" +*/}
            {/*        "⏳29 октября, 18:00\n" +*/}
            {/*        "\n" +*/}
            {/*        "🌍Клуб IZI\n" +*/}
            {/*        "Москва, Басманный переулок, дом 8, строение 1\n" +*/}
            {/*        "\n" +*/}
            {/*        "Этим вечером для вас выступят:\n" +*/}
            {/*        "\n" +*/}
            {/*        "🎃 IRRAKRA\n" +*/}
            {/*        "LED-Show Metal\n" +*/}
            {/*        "\n" +*/}
            {/*        "🎃 ONE MORE TALE\n" +*/}
            {/*        "Symphonic Metal\n" +*/}
            {/*        "\n" +*/}
            {/*        "🎃 Divided Island\n" +*/}
            {/*        "UltraViolet Rock\n" +*/}
            {/*        "\n" +*/}
            {/*        "🎃 CYBER HUNTERZ\n" +*/}
            {/*        "Neuropunk, Psystyle, Dancecore, Hardstyle, Brakes, Cinematic Rave\n" +*/}
            {/*        "\n" +*/}
            {/*        "И на этом список участников шоу не заканчивается! Также в программе вечера яркие ведущие, обворожительные танцовщицы и многие другие.\n" +*/}
            {/*        "\n" +*/}
            {/*        "✅В зале имеется несколько вариантов размещения гостей.\n" +*/}
            {/*        "\n" +*/}
            {/*        "ТАНЦПОЛ (1 этаж) — бары, фотозона, танцевальная площадка, где можно отлично провести время активной компанией.\n" +*/}
            {/*        "\n" +*/}
            {/*        "VIP (2 этаж) — здесь можно уютно разместиться за столиками. Также имеется бар. (с возможностью выхода на танцпол)\n" +*/}
            {/*        "\n" +*/}
            {/*        "LUX — приватная зона на втором этаже сбоку, подальше от чужих глаз, откуда открывается отличный вид на сцену. Билеты можно заказать только в предпродаже. Количество мест ограничено. Вход строго 12+. За покупку билета на два лица в зону LUX — ПОДАРОК!\n" +*/}
            {/*        "Также для обладателей билетов категории LUX бесплатная беспроигрышная лотерея \"Древо Хэллоуина\".\n" +*/}
            {/*        "\n" +*/}
            {/*        "Дети младше 12 лет проходят на мероприятие ⚠БЕСПЛАТНО⚠ (строго в сопровождении взрослых).\n" +*/}
            {/*        "\n" +*/}
            {/*        "📕Также доступно бронирование столов. Об этом - в следующих публикациях.\n" +*/}
            {/*        "Следите за новостями🤘"}</pre>*/}

            {/*        <Link href={"https://one-more-tale.timepad.ru/event/2465819/"} color="inherit" underline="none"*/}
            {/*              style={{display: "flex", justifyContent: "center"}}>*/}
            {/*            БИЛЕТЫ ТУТ!*/}
            {/*        </Link>*/}


            {/*    </div>*/}
            {/*</div>*/}

            <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                <div style={{marginTop: 20}}>
                    <Image src={valpur} size={'huge'}/>
                    {/*<div style={{marginTop: 40, textAlign: 'center', fontSize: 26}}></div>*/}
                    <pre style={{
                        maxWidth: 600,
                        marginLeft: 40,
                        textWrap: 'wrap',
                        whiteSpace: 'pre-wrap',
                        wordWrap: 'break-word',
                        overflowWrap: 'break-word'
                    }} className={'PalatinoFont'}>{"Друзья, анонсируем следующее наше выступление в Москве!🔥🔥🔥 После, в Москве, увидимся только осенью😉 Потому будем рады увидеть наших друзей на этой умопомрачительной тусе🤗🤗🤗" +
                    "\n\nВесна уже близко! И чем громче звучат ее шаги, тем ближе самый таинственный и мистический праздник - Вальпургиева ночь!\n" +
                    "Сегодня мы призываем всех вас присоединиться к нашему огненному шабашу! 12 часов самой прекрасной музыки и самых жарких костров ждут вас 28 апреля в Mezzo Forte! День и ночь мы будем сжигать зиму и призывать лето! Мы будем сгорать и возрождаться! Это пиршество запомнится надолго! Мы ждем именно тебя.\n" +
                    "\n" +
                    "Место проведения:\n" +
                    "МОСКВА\n" +
                    "Клуб MEZZO FORTE CLUB, 1-я Останкинская ул. 53\n" +
                    "Метро: ВДНХ\n" +
                    "\n" +
                    "⏰Start: 18:00\n" +
                    "End: 06.00\n" +
                    "💶Цена билетов:\n" +
                    "От 900 рублей (в самой ранней продаже, есть билеты \"ночь\")"}</pre>
                </div>
                <Link href={"https://vk.com/valpurgis_night2024"} color="inherit" underline="none"
                      style={{display: "flex", justifyContent: "center", marginTop: 20}}>
                    Мероприятие тут!
                </Link>
                <Link href={"https://vk.com/away.php?to=https%3A%2F%2Frupor.biz%2Fwidgets%2Fevent-tickets%2F955&post=-225202919_11&cc_key=&track_code="} color="inherit" underline="none"
                      style={{display: "flex", justifyContent: "center", marginTop: 20}}>
                    Билеты тут!
                </Link>
            </div>

            <div style={{display: "flex", flexDirection: "column", alignItems: "center", borderTop: "1px solid white", marginTop: 40}}>
                <div style={{marginTop: 20}}>
                    <Image src={descent} size={'huge'}/>
                    {/*<div style={{marginTop: 40, textAlign: 'center', fontSize: 26}}></div>*/}
                    <pre style={{
                        maxWidth: 600,
                        marginLeft: 40,
                        textWrap: 'wrap',
                        whiteSpace: 'pre-wrap',
                        wordWrap: 'break-word',
                        overflowWrap: 'break-word'
                    }} className={'PalatinoFont'}>{"Совсем скоро мы приедем к вам! \nГотов ли ты погрузиться во тьму изредка разрываемую тысячами неоновых вспышек? Готов ли отдаться очарованию мистики и темной эстетики?\n" +
                    "Если да, то мы ждем именно тебя. Надевай свои самые нуарные наряды, захвати с собой хорошее настроение и приходи!"}</pre>
                </div>
                <Link href={"https://vk.com/descent_to_dark_voronezh?trackcode=c4b703cdkbTF0Hdg8iQ_zIVuZB0b3hhPwhAoxjrDXqC7ZtaNVbE61U1NlmKeXSjEnmFXExDtKlXyHireOd9EoKpsifk00w"} color="inherit" underline="none" style={{display: "flex", justifyContent: "center", marginTop: 20}}>
                    Воронеж
                </Link>
                <Link href={"https://vk.com/descent_to_dark_rostov?trackcode=17a3aa73JC227-wxCcIg2Dt8xyutXS6DGSkBTt1R3RUhVhtk8f6PTFhhGTNluzfQIHP0JaZuHJkpJwNW3k3HFTBcRBCQnA"} color="inherit" underline="none" style={{display: "flex", justifyContent: "center", marginTop: 20}}>
                    Ростов
                </Link>
                <Link href={"https://vk.com/descent_to_dark_kras?trackcode=4fc8d658Lg7MxvHYl1xv3JBN66lmRtRE_ncMisNvqsrxJQHRnZiFbxVBBNr7JXjUi0LYp2115l7OeQ6SwHOwyuAvXqX8-g"} color="inherit" underline="none" style={{display: "flex", justifyContent: "center", marginTop: 20}}>
                    Краснодар
                </Link>
                <Link href={"https://vk.com/descent_to_dark_volgograd?trackcode=da75d4c9HWEbl0vyuXDZ80fndT7Q8Mr7sWezZ5ojqBWsuQMRgxW2AIAVvvDVCc77XOhGMNvD-OGBabF_mT-yFb2zXGXidw"} color="inherit" underline="none" style={{display: "flex", justifyContent: "center", marginTop: 20}}>
                    Волгоград
                </Link>
                <Link href={"https://vk.com/descent_to_dark_samara?trackcode=29aa8005ZT25dRk_pLjSbNA6P6bQOrWVRnTcVzzwHvAhEcyf1OzOXACH-j3IwcVkyzUMqNsJh492et5PP-wE8DAbk-u1jg"} color="inherit" underline="none" style={{display: "flex", justifyContent: "center", marginTop: 20}}>
                    Самара
                </Link>
                <Link href={"https://vk.com/descent_to_dark_nnovgorod?trackcode=c993ab46tm_CeURVy2rik0TqWIyGNleoxQZ-AZ4oqu0L4CNlwpIdDgixp1enE_WbX-Vrgo0FZbL1CHwZnTSw7RrqfBGj8A"} color="inherit" underline="none" style={{display: "flex", justifyContent: "center", marginTop: 20}}>
                    Нижний Новгород
                </Link>
            </div>

        </div>

    </div>
}
